import { inject } from 'vue';

import { BRANDING_INJECTION_KEY, defaultBranding } from '../branding';
import type { BrandingConfig } from '../branding/types';

/**
 * 현재 앱에 주입된 BrandingConfig를 반환한다.
 *
 * createAxApp이 `app.provide('branding', options.branding ?? defaultBranding)`
 * 으로 주입한 값을 inject한다. provide 미수행 시 defaultBranding을 폴백.
 *
 * docs/06-branding.md §5.2 — 모든 컴포넌트는 브랜딩 요소 하드코딩 금지,
 * 반드시 이 composable을 통해 참조.
 */
export function useBranding(): BrandingConfig {
  return inject<BrandingConfig>(BRANDING_INJECTION_KEY, defaultBranding);
}
